@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/spacing.module.less';

.warning-modal-body {
  margin: 20px;
  width: 450px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  border: 1px solid var(--gold-300);
  background: var(--gold-200);
}

.modal-buttons {
  display: flex;
  justify-content: right;
  height: 100%;
  align-items: center;
}

.modal-body-header {
  padding-top: @space-8;
  width: 390px;
  display: inline-block;
  .truncate();
}

.confirm-button {
  margin-left: 20px;
  border: 1px solid var(--red-700);
  background: var(--red-600);
  color: var(--white);
  &:hover {
    background: var(--red-600);
  }
}

.warning-content {
  display: flex;
  padding: @space-4 @space-8;
  align-items: center;
  align-self: stretch;

  .warning-icon {
    height: 24px;
    width: 100%;
    vertical-align: middle;
    margin: 0 20px 3px 1px;
    color: var(--gold-500);
  }

  .warning-text {
    flex: 1 0 0;
  }
}
